import React, { useRef, useState } from 'react';

const CalendarPicker = ({ onDateSelect }) => {
    const dateInputRef = useRef(null);
    const [selectedDate, setSelectedDate] = useState('');

    const handleIconClick = () => {
        if (dateInputRef.current) {
            dateInputRef.current.showPicker();
            dateInputRef.current.click();
            dateInputRef.current.focus();
        }
    };

    const handleDateChange = (event) => {
        const value = event.target.value;
        setSelectedDate(value);
        onDateSelect(value); // notify parent
    };

    return (
        <div className="calendar-picker">
            <img
                src="/images/CalendarIcon.png"
                alt="Calendar"
                className="calendar-icon"
                onClick={handleIconClick}
            />
            <input
                type="date"
                ref={dateInputRef}
                className="hidden-date-input"
                value={selectedDate}
                onChange={handleDateChange}
            />
        </div>
    );
};

export default CalendarPicker;
